import { rwd, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const StepContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  max-height: 100vh;
  margin-left: ${Spacing.S32};
  padding: 0 ${Spacing.S32};

  ${rwd.equalOrLessThan('xlarge')} {
    margin-left: 92px;
  }
`
